<script setup>
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';
import microsoftChannelClient from 'dashboard/api/channel/microsoftChannelClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await microsoftChannelClient.create({
      email: props.inbox.email,
    });

    const {
      data: { url },
    } = response;
    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.MICROSOFT_CHANNEL.ERROR_MESSAGE'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired
    :inbox="inbox"
    :title="$t('INBOX_MGMT.REAUTHORIZE.MICROSOFT_CHANNEL.TITLE')"
    :description="$t('INBOX_MGMT.REAUTHORIZE.MICROSOFT_CHANNEL.DESCRIPTION')"
    :is-requesting-authorization="isRequestingAuthorization"
    class="mx-8 mt-5"
    @reauthorize="requestAuthorization"
  />
</template>
